/* tslint:disable */
/* eslint-disable */
/**
 * Shared Service API
 * Shared Service API documentation.
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, } from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI, } from '../base';
/**
 * PayoutsApi - axios parameter creator
 * @export
 */
export const PayoutsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Callback function called by Airwallex  See [Airwallex docs for header details]{@link https://www.airwallex.com/docs/developer-tools__listen-for-webhook-events#delivery-headers}
         * @param {object} body Body received from Airwallex
         * @param {string} [xSignature] Custom header from Airwallex
         * @param {string} [xTimestamp] Custom header from Airwallex
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payoutControllerAirwallexCallback: (body, xSignature, xTimestamp, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('payoutControllerAirwallexCallback', 'body', body);
            const localVarPath = `/payout/airwallex-callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xSignature != null) {
                localVarHeaderParameter['x-signature'] = String(xSignature);
            }
            if (xTimestamp != null) {
                localVarHeaderParameter['x-timestamp'] = String(xTimestamp);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AuthorisePayoutsDto} authorisePayoutsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payoutControllerAuthorise: (authorisePayoutsDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'authorisePayoutsDto' is not null or undefined
            assertParamExists('payoutControllerAuthorise', 'authorisePayoutsDto', authorisePayoutsDto);
            const localVarPath = `/payout/authorise`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(authorisePayoutsDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {boolean} [allowPayments] Filter by denormalised payout eligibility. false &#x3D; payments held (workspace or client). Retool initiate/authorise queues use allowPayments&#x3D;true with status.
         * @param {string} [name]
         * @param {Array<PayoutStatusEnum>} [status]
         * @param {string} [beneficiaryWorkspaceId]
         * @param {string} [paymentDateFrom]
         * @param {string} [paymentDateTo]
         * @param {string} [payoutGenerationTimestampFrom]
         * @param {string} [payoutGenerationTimestampTo]
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payoutControllerFindAll: (allowPayments, name, status, beneficiaryWorkspaceId, paymentDateFrom, paymentDateTo, payoutGenerationTimestampFrom, payoutGenerationTimestampTo, page, pageSize, sortBy, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/payout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (allowPayments !== undefined) {
                localVarQueryParameter['allowPayments'] = allowPayments;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (status) {
                localVarQueryParameter['status'] = status;
            }
            if (beneficiaryWorkspaceId !== undefined) {
                localVarQueryParameter['beneficiaryWorkspaceId'] =
                    beneficiaryWorkspaceId;
            }
            if (paymentDateFrom !== undefined) {
                localVarQueryParameter['paymentDateFrom'] =
                    paymentDateFrom instanceof Date
                        ? paymentDateFrom.toISOString()
                        : paymentDateFrom;
            }
            if (paymentDateTo !== undefined) {
                localVarQueryParameter['paymentDateTo'] =
                    paymentDateTo instanceof Date
                        ? paymentDateTo.toISOString()
                        : paymentDateTo;
            }
            if (payoutGenerationTimestampFrom !== undefined) {
                localVarQueryParameter['payoutGenerationTimestampFrom'] =
                    payoutGenerationTimestampFrom instanceof Date
                        ? payoutGenerationTimestampFrom.toISOString()
                        : payoutGenerationTimestampFrom;
            }
            if (payoutGenerationTimestampTo !== undefined) {
                localVarQueryParameter['payoutGenerationTimestampTo'] =
                    payoutGenerationTimestampTo instanceof Date
                        ? payoutGenerationTimestampTo.toISOString()
                        : payoutGenerationTimestampTo;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payoutControllerFindOne: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('payoutControllerFindOne', 'id', id);
            const localVarPath = `/payout/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {InitiatePayoutsDto} initiatePayoutsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payoutControllerInitiate: (initiatePayoutsDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'initiatePayoutsDto' is not null or undefined
            assertParamExists('payoutControllerInitiate', 'initiatePayoutsDto', initiatePayoutsDto);
            const localVarPath = `/payout/initiate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(initiatePayoutsDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PayoutsApi - functional programming interface
 * @export
 */
export const PayoutsApiFp = function (configuration) {
    const localVarAxiosParamCreator = PayoutsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Callback function called by Airwallex  See [Airwallex docs for header details]{@link https://www.airwallex.com/docs/developer-tools__listen-for-webhook-events#delivery-headers}
         * @param {object} body Body received from Airwallex
         * @param {string} [xSignature] Custom header from Airwallex
         * @param {string} [xTimestamp] Custom header from Airwallex
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payoutControllerAirwallexCallback(body, xSignature, xTimestamp, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.payoutControllerAirwallexCallback(body, xSignature, xTimestamp, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {AuthorisePayoutsDto} authorisePayoutsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payoutControllerAuthorise(authorisePayoutsDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.payoutControllerAuthorise(authorisePayoutsDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {boolean} [allowPayments] Filter by denormalised payout eligibility. false &#x3D; payments held (workspace or client). Retool initiate/authorise queues use allowPayments&#x3D;true with status.
         * @param {string} [name]
         * @param {Array<PayoutStatusEnum>} [status]
         * @param {string} [beneficiaryWorkspaceId]
         * @param {string} [paymentDateFrom]
         * @param {string} [paymentDateTo]
         * @param {string} [payoutGenerationTimestampFrom]
         * @param {string} [payoutGenerationTimestampTo]
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payoutControllerFindAll(allowPayments, name, status, beneficiaryWorkspaceId, paymentDateFrom, paymentDateTo, payoutGenerationTimestampFrom, payoutGenerationTimestampTo, page, pageSize, sortBy, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.payoutControllerFindAll(allowPayments, name, status, beneficiaryWorkspaceId, paymentDateFrom, paymentDateTo, payoutGenerationTimestampFrom, payoutGenerationTimestampTo, page, pageSize, sortBy, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payoutControllerFindOne(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.payoutControllerFindOne(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {InitiatePayoutsDto} initiatePayoutsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payoutControllerInitiate(initiatePayoutsDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.payoutControllerInitiate(initiatePayoutsDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PayoutsApi - factory interface
 * @export
 */
export const PayoutsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PayoutsApiFp(configuration);
    return {
        /**
         *
         * @summary Callback function called by Airwallex  See [Airwallex docs for header details]{@link https://www.airwallex.com/docs/developer-tools__listen-for-webhook-events#delivery-headers}
         * @param {object} body Body received from Airwallex
         * @param {string} [xSignature] Custom header from Airwallex
         * @param {string} [xTimestamp] Custom header from Airwallex
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payoutControllerAirwallexCallback(body, xSignature, xTimestamp, options) {
            return localVarFp
                .payoutControllerAirwallexCallback(body, xSignature, xTimestamp, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AuthorisePayoutsDto} authorisePayoutsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payoutControllerAuthorise(authorisePayoutsDto, options) {
            return localVarFp
                .payoutControllerAuthorise(authorisePayoutsDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} [allowPayments] Filter by denormalised payout eligibility. false &#x3D; payments held (workspace or client). Retool initiate/authorise queues use allowPayments&#x3D;true with status.
         * @param {string} [name]
         * @param {Array<PayoutStatusEnum>} [status]
         * @param {string} [beneficiaryWorkspaceId]
         * @param {string} [paymentDateFrom]
         * @param {string} [paymentDateTo]
         * @param {string} [payoutGenerationTimestampFrom]
         * @param {string} [payoutGenerationTimestampTo]
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payoutControllerFindAll(allowPayments, name, status, beneficiaryWorkspaceId, paymentDateFrom, paymentDateTo, payoutGenerationTimestampFrom, payoutGenerationTimestampTo, page, pageSize, sortBy, options) {
            return localVarFp
                .payoutControllerFindAll(allowPayments, name, status, beneficiaryWorkspaceId, paymentDateFrom, paymentDateTo, payoutGenerationTimestampFrom, payoutGenerationTimestampTo, page, pageSize, sortBy, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payoutControllerFindOne(id, options) {
            return localVarFp
                .payoutControllerFindOne(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {InitiatePayoutsDto} initiatePayoutsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payoutControllerInitiate(initiatePayoutsDto, options) {
            return localVarFp
                .payoutControllerInitiate(initiatePayoutsDto, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * PayoutsApi - object-oriented interface
 * @export
 * @class PayoutsApi
 * @extends {BaseAPI}
 */
export class PayoutsApi extends BaseAPI {
    /**
     *
     * @summary Callback function called by Airwallex  See [Airwallex docs for header details]{@link https://www.airwallex.com/docs/developer-tools__listen-for-webhook-events#delivery-headers}
     * @param {object} body Body received from Airwallex
     * @param {string} [xSignature] Custom header from Airwallex
     * @param {string} [xTimestamp] Custom header from Airwallex
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayoutsApi
     */
    payoutControllerAirwallexCallback(body, xSignature, xTimestamp, options) {
        return PayoutsApiFp(this.configuration)
            .payoutControllerAirwallexCallback(body, xSignature, xTimestamp, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AuthorisePayoutsDto} authorisePayoutsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayoutsApi
     */
    payoutControllerAuthorise(authorisePayoutsDto, options) {
        return PayoutsApiFp(this.configuration)
            .payoutControllerAuthorise(authorisePayoutsDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {boolean} [allowPayments] Filter by denormalised payout eligibility. false &#x3D; payments held (workspace or client). Retool initiate/authorise queues use allowPayments&#x3D;true with status.
     * @param {string} [name]
     * @param {Array<PayoutStatusEnum>} [status]
     * @param {string} [beneficiaryWorkspaceId]
     * @param {string} [paymentDateFrom]
     * @param {string} [paymentDateTo]
     * @param {string} [payoutGenerationTimestampFrom]
     * @param {string} [payoutGenerationTimestampTo]
     * @param {number} [page] The page number to retrieve, default &#x3D; 1
     * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
     * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayoutsApi
     */
    payoutControllerFindAll(allowPayments, name, status, beneficiaryWorkspaceId, paymentDateFrom, paymentDateTo, payoutGenerationTimestampFrom, payoutGenerationTimestampTo, page, pageSize, sortBy, options) {
        return PayoutsApiFp(this.configuration)
            .payoutControllerFindAll(allowPayments, name, status, beneficiaryWorkspaceId, paymentDateFrom, paymentDateTo, payoutGenerationTimestampFrom, payoutGenerationTimestampTo, page, pageSize, sortBy, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayoutsApi
     */
    payoutControllerFindOne(id, options) {
        return PayoutsApiFp(this.configuration)
            .payoutControllerFindOne(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {InitiatePayoutsDto} initiatePayoutsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayoutsApi
     */
    payoutControllerInitiate(initiatePayoutsDto, options) {
        return PayoutsApiFp(this.configuration)
            .payoutControllerInitiate(initiatePayoutsDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
